import type { UserInfoDataType } from '@/models/types/auth.types'
import { ref } from 'vue'
import { defineStore } from 'pinia'
import { STORAGE_USER } from '@/constants/storageKey.const'

export const useUserStore = defineStore(
  'user',
  () => {
    const token = ref<string>('')
    const userInfo = ref<UserInfoDataType>({
      name: '',
      userId: '',
      roleOrder: 0,
      photoUrl: '',
      goodsIsVisibleSwitch: false,
      timeZoneId: ''
    })
    // 密碼是否已超過 180 天未更換（OP#2664），登入後由 fnLogin 設定，
    // 觸發 usePasswordExpiryPrompt 彈出提示
    const isPwdNotChangeOver180Days = ref<boolean>(false)

    const initLoginState = (): void => {
      token.value = ''
      userInfo.value = {
        name: '',
        userId: '',
        roleOrder: 0,
        photoUrl: '',
        goodsIsVisibleSwitch: false,
        timeZoneId: ''
      }
      isPwdNotChangeOver180Days.value = false
    }

    return {
      token,
      userInfo,
      isPwdNotChangeOver180Days,
      initLoginState
    }
  },
  {
    persist: {
      key: STORAGE_USER
    }
  }
)
